import * as $ from 'jquery';
import Component from '../../Component';
import Submit from '../../Components/Submit';
import { STATUS } from '../../General';
import BraintreeHostedFields from './BraintreeHostedFields';
import Table from './Table';

export default class ReviewAndOrder extends Component {
    constructor(props?: any) {
        super(props);
        this.state = {
            braintreeSettings: {
                value: undefined,
                status: STATUS.LOADING
            },
            braintree: {
                status: STATUS.LOADING
            },
            orderAndPay: {
                pleaseWait: false
            },
            braintreeNonce: undefined,
            braintreeBin: undefined,
            threeDSecureAuthenticationId: undefined,
            paymentMethodValid: false,
            cardLastFour: undefined,
            cardExpiresOn: undefined,
        };
    }

    componentDidMount() {
        this.getBraintreeSettings();
    }

    getBraintreeSettings() {
        $.ajax({
            type: 'GET',
            contentType: 'application/json',
            url: this.Endpoints().getBraintreeSettings(this.props.subscriptionOrder.currency),
            dataType: 'json',
            cache: false,
            success: (data, textStatus, jqXHR) => {
                this.setState({
                    braintreeSettings: {
                        value: data,
                        status: STATUS.READY
                    }
                });
            },
            error: (jqXHR, textStatus, errorThrown) => {
                this.ajaxError(jqXHR, textStatus, errorThrown);
                this.setState({
                    orderSettings: {
                        value: undefined,
                        status: STATUS.ERROR
                    },
                });
            },
        });
    }

    render() {
        let ready = this.state.braintreeSettings.status === STATUS.READY;
        if (ready === false) {
            return this.renderLoading();
        }
        const t = this.translate();
        return <div className={this.getCardClassNameSize()
        } >
            <div className="card-body">
                <div className="row">
                    <div className="col-12">
                        <Table subscriptionOrder={this.props.subscriptionOrder} />
                    </div>
                    {(!this.isFormValid()) ?
                        <div className="col-12 mb-3">
                            <BraintreeHostedFields
                                subscriptionOrder={this.props.subscriptionOrder}
                                braintreeSettings={this.state.braintreeSettings.value}
                                onValidationComplete={(payload: any) => {
                                    console.log(payload);
                                    this.setState({
                                        paymentMethodValid: true, braintreeNonce: payload.nonce, threeDSecureAuthenticationId: payload.threeDSecureAuthenticationId,
                                        cardLastFour: payload.cardLastFour, cardExpiresOn: payload.cardExpiresOn
                                    }, () => {
                                        this.forceUpdate();
                                    });
                                    //                                        this.setState({ paymentMethodValid: true, braintreeNonce: payload.nonce, threeDSecureAuthenticationId: undefined }, () => { this.validateDropin() });
                                }}
                                onBraintreeWebDropInReady={() => {
                                    this.setState({ paymentMethodValid: true });
                                }}
                                onNoPaymentMethodRequestable={() => {
                                    this.setState({ paymentMethodValid: false, braintreeNonce: undefined, threeDSecureAuthenticationId: undefined });
                                }}
                            />
                        </div> : <></>
                    }
                    {(!this.isFormValid()) ?
                        <div className="col-12 mb-3">
                            <small>{t('note.we.accept.only.cards.from.visa.and.mastercard')}</small>
                        </div> : <></>
                    }
                </div>
            </div>
            {(this.isFormValid()) ?
                <div className="card-body">
                    <form onSubmit={(event: any) => { this.submit(event); }}>
                        <fieldset>
                            <div className="row">
                                <div className="col-12 mb-3">
                                    <Submit
                                        faIcon="fa fa-shopping-cart"
                                        disabled={!this.isFormValid()}
                                        pleaseWait={this.state.orderAndPay.pleaseWait}
                                        color={this.state.braintreeNonce ? 'success btn-lg' : 'outline-primary'}
                                    >
                                        {t('pay')}
                                        {this.state.cardLastFour ? <><br />{t('using.card.that.ends.with') + ' ' + this.state.cardLastFour}</> : <></>}
                                        {this.state.cardExpiresOn ? <><br />{t('and.expires.on') + ' ' + this.state.cardExpiresOn}</> : <></>}
                                    </Submit>
                                </div>
                            </div>
                        </fieldset>
                    </form>
                </div>
                : <></>
            }
        </div>
    }

    isFormValid() {
        return this.state.paymentMethodValid;
    }

    submit(event: any) {
        event.preventDefault();
        if (this.isFormValid() || false) {
            //            if (this.validateDropin() === false) return;
            const subscriptionOrder = Object.assign({}, this.props.subscriptionOrder);
            delete subscriptionOrder.country;
            $.ajax({
                type: 'PUT',
                contentType: 'application/json',
                url: this.Endpoints().getSubscriptionOrder(),
                dataType: 'json',
                cache: false,
                data: JSON.stringify(
                    {
                        subscriptionOrder: subscriptionOrder,
                        braintreeNonce: this.state.braintreeNonce,
                        threeDSecureAuthenticationId: this.state.threeDSecureAuthenticationId
                    }
                ),
                beforeSend: () => {
                    this.setState({ orderAndPay: { pleaseWait: true } });
                },
                success: (data, textStatus, jqXHR) => {
                    this.setState({ braintreeNonce: null });
                    if (this.props.onOrdered) {
                        this.props.onOrdered();
                    }
                },
                error: (jqXHR, textStatus, errorThrown) => {
                    this.ajaxError(jqXHR, textStatus, errorThrown);
                    this.setState({ orderAndPay: { pleaseWait: false } });
                },
            });
        }
    }
}